import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react'; // ✅ Nice external link icon

import './Apply.css';

export default function Apply() {
  return (
    <div className="container">
      <motion.h1
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        style={{ textAlign: 'center', marginBottom: '2rem' }}
      >
        Apply
      </motion.h1>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="apply-cards-container"
      >
        {/* Become a Tutor Card */}
        <div className="apply-card">
          <div className="apply-card-header">
            <h3>Become a Tutor</h3>
            <a
              href="https://forms.gle/6T6kPeqvYX3V9RHz7"
              target="_blank"
              rel="noopener noreferrer"
              className="open-new-tab"
              title="Open form in a new tab"
            >
              <ExternalLink size={18} />
            </a>
          </div>
          <p className="apply-card-desc">
            Are you a high school or university student looking to make a difference? Join our
            team of volunteer tutors and mentor one or more K-9 students.
          </p>
          <iframe
            title="Tutor Form"
            src="https://forms.gle/6T6kPeqvYX3V9RHz7?embedded=true"
            width="100%"
            height="500"
          ></iframe>
        </div>

        {/* Request Tutoring Card */}
        <div className="apply-card">
          <div className="apply-card-header">
            <h3>Request Tutoring</h3>
            <a
              href="https://forms.gle/7FUqcLRu68ikL3rB6"
              target="_blank"
              rel="noopener noreferrer"
              className="open-new-tab"
              title="Open form in a new tab"
            >
              <ExternalLink size={18} />
            </a>
          </div>
          <p className="apply-card-desc">
            Need support with schoolwork? Families with students in grades K-9 can
            request a free high school or university tutor.
          </p>
          <iframe
            title="Tutee Form"
            src="https://forms.gle/7FUqcLRu68ikL3rB6?embedded=true"
            width="100%"
            height="500"
          ></iframe>
        </div>
      </motion.div>
    </div>
  );
}
